module.exports = __webpack_public_path__ + "img/george-jones.4aa66cc9.png";